<template lang="pug">
ul.nav(v-if="menus")
	li(v-if="$helpers.isAgentLevel() && ['MYR', 'THB', 'SGD', 'USD', 'CNY'].includes($store.getters.getAccountCurrency)" @click="dismissSidebar" :class="{ 'active': $route.path == '/accountListAlert' }")
		router-link(to="/accountListAlert")
			i.fa.fa-bell.pull-right.text-warning(v-if="$store.getters.getPlayerAlert")
			i.fa.fa-list
			span {{ $t("ui.account_list_alert") }}
	//- li.nav-header Navigation
	template(v-for="menu in menus")
		sidebar-nav-list(
			ref="sidebarNavList"
			:menu="menu"
			:scroll-top="scrollTop"
			:key="menu.path"
			:status="menu.status"
			@collapse-other="handleCollapseOther(menu)"
			@showFloatSubmenu="handleShowFloatSubmenu"
			@hideFloatSubmenu="handleHideFloatSubmenu"
		)
	// here need to add a new menu for "settings" for the user to bind or unbind the OTP 2FA or Telegram OTP
	li
		router-link(to="/settings")
			i.fa.fa-cog
			span {{ $t("ui.settings") }}
	li(v-if="config.brand !== 'fotbet'")
		a(href="https://wbmarketingtools.com" target="_blank" @click="dismissSidebar")
			i.fa.fa-link
			span {{ $t("ui.marketing_tools") }}
	li
		router-link(to="/gameRules")
			i.fa.fa-info
			span {{ $t("ui.game_rules") }}


	//- li
	//- 	a.sidebar-minify-btn(href="#" @click="handleSidebarMinify()")
	//- 		i.fa.fa-angle-double-left
</template>

<script>
import SidebarMenu from './SidebarMenu.vue'
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'
import config from '@/config'

export default {
	name: 'SidebarNav',
	components: {
		SidebarNavList
	},
	props: ['scrollTop'],
	data () {
		return {
			pageOptions: PageOptions,
			config
		}
	},
	computed: {
		menus () {
			// Depend on isPartner so Member Mgmt children re-evaluate after checkPartner
			void this.$store.getters.isPartner;
			return (SidebarMenu || []).filter(menu => menu && menu.path);
		}
	},
	methods: {
		handleShowFloatSubmenu: function(menu, offset) {
			this.$emit('showFloatSubmenu', menu, offset);
		},
		handleHideFloatSubmenu: function() {
			this.$emit('hideFloatSubmenu');
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.menus.length; i++) {
				this.$refs.sidebarNavList[i].collapse(menu);
			}
		},
		handleSidebarMinify: function() {
			this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
		},
		dismissSidebar: function() {
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
    }
	}
}
</script>
